import { Navigate } from "react-router-dom";
import React from "react";

const notFoundRoute = "/NotFound/";
export const NotFoundNavigation = () => <Navigate to={notFoundRoute} replace />;
